import ImagesGalleryRowComponent from "components/core/images-gallery/images-gallery-row/images-gallery-row-component";
import { componentStyles } from "./badges-grid-desktop-component.scss";

const BadgesGridDesktopComponent = ({ badges }) => (
  <div className="badges-grid-desktop-component">
    <ImagesGalleryRowComponent assets={badges} />
    <style jsx>{componentStyles}</style>
  </div>
);

export default BadgesGridDesktopComponent;
